import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        modal: {
            position: 'fixed',
            zIndex: 1201,
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            overflow: 'auto',
            background: 'background.overlay-modal',
            display: 'flex',
            alignContent: 'center',
        },
        content: {
            marginX: {base: `${remCalc(16)}`, lg: 'auto'},
            marginY: {base: remCalc(16), lg: 'auto'},
            borderWidth: remCalc(1),
            borderBottom: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            borderRadius: remCalc(8),
            width: {base: 'auto', lg: remCalc(688)},
            padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
            position: 'relative',
            background: 'background.default',
            flexDirection: 'column',
        },
        close: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
        },
        text: {
            textStyle: 'body-large',
            color: 'text.default',
            borderBottom: 'small',
            borderColor: 'border.dark',
            borderStyle: 'solid',
            paddingBottom: remCalc(16),
            marginBottom: {base: remCalc(16), md: remCalc(24)},
            paddingRight: remCalc(24),
        },
    },
    variants: {
        wishlist: {
            content: {
                padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 'medium',
                color: 'text.default',
                paddingBottom: remCalc(16),
            },
            text: {
                marginBottom: {base: remCalc(24), lg: remCalc(40)},
            },
        },
        native: {},
    },
}
